var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 8.89543 15.9594 8 17.1429 8H30.8571C32.0406 8 33 8.89543 33 10C33 11.1046 32.0406 12 30.8571 12H17.1429C15.9594 12 15 11.1046 15 10Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.00001L15.8907 9L15.8907 9C14.5865 8.99993 13.7206 8.99989 13.0697 9.09472C12.3016 9.20663 11.8087 9.45072 11.2222 9.84266C10.6762 10.2075 10.2074 10.6762 9.84265 11.2222C9.37751 11.9183 9.18171 12.7052 9.0894 13.6127C8.99997 14.4917 8.99999 15.5874 9 16.946V16.9461V36.0732C8.99997 37.8966 8.99995 39.3664 9.15537 40.5223C9.31672 41.7225 9.66191 42.733 10.4645 43.5355C11.267 44.3381 12.2775 44.6833 13.4777 44.8446C14.6336 45.0001 16.1033 45 17.9268 45H17.9268H30.0732H30.0732C30.1352 45 30.1967 45 30.2579 45L28.1838 43H18C16.0861 43 14.7513 42.9979 13.7442 42.8625C12.7658 42.7309 12.2477 42.4903 11.8787 42.1213C11.5097 41.7523 11.2691 41.2342 11.1375 40.2558C11.0021 39.2487 11 37.9139 11 36V17C11 15.5747 11.0012 14.581 11.0791 13.8151C11.1554 13.0658 11.2966 12.646 11.5056 12.3333C11.7245 12.0057 12.0057 11.7245 12.3333 11.5056C12.7556 11.2234 12.9694 11.1305 13.358 11.0738C13.8458 11.0028 14.5565 11 16 11V9.00001ZM37 34.4987L39 32.5701V16.9461V16.946C39 15.5874 39 14.4917 38.9106 13.6127C38.8183 12.7052 38.6225 11.9183 38.1574 11.2222C37.7926 10.6762 37.3238 10.2075 36.7779 9.84266C36.1913 9.45072 35.6984 9.20663 34.9303 9.09472C34.2794 8.99989 33.4135 8.99993 32.1093 9L32 9.00001V11C33.4435 11 34.1542 11.0028 34.642 11.0738C35.0306 11.1305 35.2444 11.2234 35.6667 11.5056C35.9943 11.7245 36.2755 12.0057 36.4944 12.3333C36.7034 12.646 36.8447 13.0658 36.9209 13.8151C36.9988 14.581 37 15.5747 37 17V34.4987Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37.4444L34.7143 43L45 33",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19L28 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29L26 29",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.346074965f19fc138c7be130943def60.svg";
export { ForwardRef as ReactComponent };